//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatNumberInput, formatRate } from '@/utils'
import RatePicker from './_rate_picker'
import mixin from './mixin'
import Top from '../loan_computer/_tools_base/top'

import {
    YEARS,
    LOAN_TYPES,
    PAYMENT_TYPES,
    LOAN_YEARS,
    current_date_str,
    calcPayAll,
    PREPAYMENT_TYPES,
    PUBLIC_BASE_RATES,
    PUBLIC_DISCOUNT_DEFAULT,
    PUBLIC_DISCOUNT_OPTS,
    BUSINESS_BASE_RATES,
    BUSINESS_DISCOUNT_DEFAULT,
    BUSINESS_DISCOUNT_OPTS,
    DealYearMonth
} from './utils'

export default {
    mixins: [
        mixin
    ],
    components: {
        Top,
        RatePicker,
    },
    data () {
        return {
            currentDate: new Date(),
            minDate: new Date(YEARS[0], 0, 1),
            maxDate: new Date(YEARS[YEARS.length - 1], 10, 1),
            show_date_picker: false,
            picker_title: '',
            base_moneny: '',
            prepayment_money: '',
            loan_types: LOAN_TYPES,
            loan_type_index: 0,

            payment_types: PAYMENT_TYPES,
            payment_type_index: 0,

            prepayment_types: PREPAYMENT_TYPES,
            prepayment_type_index: 0,

            loan_years: LOAN_YEARS,
            loan_year_index: LOAN_YEARS.length - 1,

            start_date: current_date_str,
            prepay_date: current_date_str,

            show_rate_picker: false,

            rate_picker_title: '',
            base_rates_opts: [],
            discount_opts: [],
            default_discount: -1,
            default_rate: -1,
            years: YEARS,
            rate: 0
        }
    },
    computed: {
        rate_show () {
            return this.rate ? this.rate.toFixed(2) : 0
        },
        is_business () {
            return Number(this.loan_type_index) === 0
        },
        is_pay_partition () {
            return Number(this.prepayment_type_index) === 1
        }
    },
    mounted () {
        this.initRate()
    },
    methods: {
        changeLoanType ({ target: { value } }) {
            this.loan_type_index = value
            this.initRate()
        },
        changePaymentType ({ target: { value } }) {
            this.payment_type_index = value
        },
        changeLoanYear ({ target: { value } }) {
            this.loan_year_index = value
        },
        changeDate(value) {
            const start_prepay_date = this.picker_title === '首次还款时间' ? 'start_date' : 'prepay_date'
            this[start_prepay_date] =  DealYearMonth(value)
            this.show_date_picker = !this.show_date_picker
        },
        toggleDatePicker(title) {
            this.picker_title = title
            this.show_date_picker = !this.show_date_picker
        },
        changePrepaymentType ({ target: { value }}) {
            this.prepayment_type_index = value
        },
        checkSubmit (params) {
            const rules = {
                base_moneny: {
                    required: true,
                    text: '原贷款金额'
                },
                prepayment_time: {
                    check: (params) => {
                        if (new Date(params.prepayment_time).getTime() < new Date(params.start_time).getTime()) {
                            return '提前还款时间不能早于首次还款时间'
                        }
                    }
                },
                prepayment_money: {
                    check: (params) => {
                        if (params.prepayment_type === '部分还款') {
                            if (!params.prepayment_money) {
                                return '请填写提前还款金额'
                            }
                            if (params.prepayment_money > params.base_moneny) {
                                return '提前还款金额不能大于原贷款金额'
                            }
                            if (params.prepayment_money === params.base_moneny) {
                                return '全部还款请选择【一次性还清】'
                            }
                            const { paid_base } = calcPayAll(params)
                            const reset_base = params.base_moneny - paid_base
                            if (reset_base < params.prepayment_money) {
                                return `提前还款金额不能超过剩余本金`
                            }
                        }
                    }
                }
            }
            return Object.keys(rules).every((key) => {
                const { required, check, text } = rules[key]
                const value = params[key]
                if (required && !value) {
                    wx.showToast({
                        title: `请填写${text}`,
                        icon: 'none'
                    })
                    return false
                }
                const check_msg = check && check(params)
                if (check_msg) {
                    wx.showToast({
                        title: check_msg,
                        icon: 'none'
                    })
                    return false
                }
                return true
            })
        },
        openResult () {
            const params = {
                payment_type: this.payment_types[this.payment_type_index],
                base_moneny: this.base_moneny,
                prepayment_money: this.prepayment_money,
                year: this.loan_years[this.loan_year_index],
                start_time: this.start_date,
                prepayment_time: this.prepay_date,
                rate: this.rate,
                prepayment_type: this.prepayment_types[this.prepayment_type_index]
            }
            if (this.checkSubmit(params)) {
                wx.navigateTo({
                    url: `/packageA/prepayment_calc/result?params=${JSON.stringify(params)}`
                })
            }
        },
        toggleRatePicker () {
            this.show_rate_picker = !this.show_rate_picker
        },
        initRate () {
            if (this.is_business) {
                this.updateRate({
                    title: '原商贷利率',
                    rates_opts: BUSINESS_BASE_RATES,
                    discount_opts: BUSINESS_DISCOUNT_OPTS,
                    discount: BUSINESS_DISCOUNT_DEFAULT
                })
            } else {
                this.updateRate({
                    title: '原公积金利率',
                    rates_opts: PUBLIC_BASE_RATES,
                    discount_opts: PUBLIC_DISCOUNT_OPTS,
                    discount: PUBLIC_DISCOUNT_DEFAULT
                })
            }
        },
        updateRate ({
            title,
            rates_opts,
            discount_opts,
            discount
        }) {
            this.rate_picker_title = title
            this.base_rates_opts = rates_opts
            this.discount_opts = discount_opts
            this.changeRateSelect(rates_opts.length - 1, discount)
        },
        changeRateSelect (rate, discount) {
            this.default_rate = rate
            this.default_discount = discount
            this.changeRate(
                formatRate(
                    Number(this.base_rates_opts[this.default_rate].value) * Number(this.discount_opts[this.default_discount].value)
                )
            )
        },
        changeRate (rate) {
            this.rate = Number(rate)
        },
        checkPrepayment (e) {
            this.prepayment_money = formatNumberInput(e)
        },
        checkBaseMoney (e) {
            this.base_moneny = formatNumberInput(e)
        }
    }
}
